import { useEffect, useState } from "react"
import { useOtcHistoryQuery } from "../../../core/services/react-query/useOrdersHistoryQuery"
import FilterLayout from "../../layouts/FilterLayout"
import { Column, Row } from "../../../styles/TableStyle"
import { FlexCenter } from "../../../styles/CommonStyles"
import { SOCKET_URL } from "../../../core/constants/urls"
import { Market, TextWithMargin } from "../../../styles/OrdersStyle"
import { formatNumber } from "../../../core/utils/common"
import Text from "../../../core/utils/Text"
import MobileModal from "../../modals/MobileModal"
import OtcHistoryDetailsModal from "./OtcDetailsModal"

const initialModalState = { show: false, data: null }

const ROtcHistoryTable = ({ setDetailsModal }) => {

    const [modal, setModal] = useState(initialModalState)
    const onCloseModal = () => setModal(initialModalState)

    const initialState = {
        page: 1,
        dateFrom: null,
        search: {
            type: 'type',
            coin: 'coin'
        },
        query: {
            type: '',
            coin: ''
        },
    }
    const [filterQueries, setFilterQueries] = useState(initialState)


    const [allPages, setAllPages] = useState(null)
    const { data: orders, isFetching, refetch } = useOtcHistoryQuery(filterQueries)

    useEffect(() => {
        if ((orders && !allPages) || (orders && orders.meta.total !== allPages)) {
            setAllPages(orders.meta.total)
        }
        // eslint-disable-next-line
    }, [orders])

    useEffect(() => {
        refetch()
    }, [filterQueries, refetch])



    return (
        <>
            <FilterLayout
                headers={headers}
                data={orders}
                totalPages={allPages}
                state={{ filterQueries, setFilterQueries, initialState }}
                loading={isFetching}
                hasCoinOption
                hasTypeOptions
            >
                {orders?.data?.map((item, index) => (
                    <Row key={item.createdAt} onClick={() => { setModal({ data: item, show: true }) }}>
                        <Column width='33.33%'>
                            <FlexCenter>
                                <img
                                    src={SOCKET_URL + `assets/icon/${item.coin}.png`}
                                    alt=' '
                                    width='18px'
                                    height='18px'
                                />
                                <Market>{item.coin}</Market>
                            </FlexCenter>
                        </Column>
                        <Column width='33.33%' number>{formatNumber(item.amount)}</Column>
                        <Column width='33.33%'>
                            <TextWithMargin type={item.type}>
                                <Text tid={item.type} />
                            </TextWithMargin>
                        </Column>
                    </Row>
                ))}
            </FilterLayout>
            <MobileModal isOpen={modal.show} onClose={onCloseModal}>
                <OtcHistoryDetailsModal data={modal.data} onClose={onCloseModal} />
            </MobileModal>
        </>

    )
}

const headers = [
    { title: 'coin', width: '33.3333%' },
    { title: 'amount', width: '33.3333%' },
    { title: 'transactionType', width: '33.3333%' },
]

export default ROtcHistoryTable
